import { render, staticRenderFns } from "./Title.vue?vue&type=template&id=2ffaf0ed&scoped=true"
import script from "./Title.vue?vue&type=script&lang=ts"
export * from "./Title.vue?vue&type=script&lang=ts"
import style0 from "./Title.vue?vue&type=style&index=0&id=2ffaf0ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffaf0ed",
  null
  
)

export default component.exports